import {
  fetchDiseaseService,
  fetchAfricaSummaryService,
  fetchCountryDataService,
} from "./api";
import {
  FETCH_DISEASE,
  FETCH_DISEASE_FAILED,
  FETCH_DISEASE_SUCCESS,
  FETCH_AFRICA_SUMMARY,
  FETCH_AFRICA_SUMMARY_FAILED,
  FETCH_AFRICA_SUMMARY_SUCCESS,
  FETCH_COUNTRY_DATA,
  // FETCH_COUNTRY_DATA_FAILED,
  FETCH_COUNTRY_DATA_SUCCESS,
} from "./types";

export const fetchDiseaseAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_DISEASE });
    const response = await fetchDiseaseService(params)();
    dispatch({ type: FETCH_DISEASE_SUCCESS, diseases: response?.data });
    return true;
  } catch (error) {
    dispatch({ type: FETCH_DISEASE_FAILED });
  }
};

var africanSummaryCount = 0;
export const fetchAfricaSummaryAction = async (dispatch) => {
  try {
    dispatch({ type: FETCH_AFRICA_SUMMARY });
    const response = await fetchAfricaSummaryService();
    dispatch({ type: FETCH_AFRICA_SUMMARY_SUCCESS, data: response?.data });
  } catch (error) {
    if (africanSummaryCount >= 5) {
      dispatch({ type: FETCH_AFRICA_SUMMARY_FAILED });
      return;
    }
    return setTimeout(() => {
      africanSummaryCount = africanSummaryCount + 1;
      dispatch(fetchAfricaSummaryAction);
    }, 2000);
  }
};

let count = 0;
export const fetchCountryDataAction = async (dispatch) => {
  try {
    dispatch({ type: FETCH_COUNTRY_DATA });
    const response = await fetchCountryDataService();
    dispatch({type: FETCH_COUNTRY_DATA_SUCCESS, data: response?.data})
  } catch (error) {
    if (count >= 5) {
      dispatch({ type: FETCH_AFRICA_SUMMARY_FAILED });
      return;
    }
    return setTimeout(() => {
      count = count + 1;
      dispatch(fetchCountryDataAction);
    }, 2000);
  }
};
